import { render, staticRenderFns } from "./LocksLayersList.vue?vue&type=template&id=2c723616&scoped=true&"
import script from "./LocksLayersList.vue?vue&type=script&lang=js&"
export * from "./LocksLayersList.vue?vue&type=script&lang=js&"
import style0 from "./LocksLayersList.vue?vue&type=style&index=0&id=2c723616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c723616",
  null
  
)

export default component.exports